(function ($, Drupal, once) {

  var DURATION = 1500;
  var FRAME_MS = 10;
  var TOTAL_FRAMES = Math.round(DURATION / FRAME_MS);

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function parseDollar(text) {
    return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
  }

  function formatNumber(value) {
    return Math.round(value).toLocaleString('en-US');
  }

  function animateNumber(el, start, end, prefix) {
    return new Promise(function (resolve) {
      var frame = 0;
      el.textContent = prefix + formatNumber(start);

      var counter = setInterval(function () {
        frame++;
        var progress = easeOutQuad(frame / TOTAL_FRAMES);
        el.textContent = prefix + formatNumber(start + (end - start) * progress);

        if (frame >= TOTAL_FRAMES) {
          clearInterval(counter);
          el.textContent = prefix + formatNumber(end);
          resolve();
        }
      }, FRAME_MS);
    });
  }

Drupal.behaviors.tuitionCostAnimate = {
    attach: function (context) {
      once('tuition-cost-animate', '.tuition-cost', context).forEach(function (container) {
        var startingEl = container.querySelector('.starting-cost');
        var totalEl = container.querySelector('.tuition-cost-total');

        if (!startingEl || !totalEl) return;

        var startVal = parseDollar(startingEl.textContent);
        var endVal = parseDollar(totalEl.textContent);

        totalEl.style.opacity = '0';
        totalEl.style.transition = 'opacity 0.6s ease-out';

        var animated = false;

        function runSequence() {
          totalEl.textContent = '= $' + formatNumber(startVal);

          setTimeout(function () {
            totalEl.style.opacity = '1';
          }, 200);

          setTimeout(function () {
            animateNumber(totalEl, startVal, endVal, '= $');
          }, 1000);
        }

        function reset() {
          totalEl.style.opacity = '0';
          totalEl.textContent = '= $' + formatNumber(endVal);
        }

        // Trigger when scrolled into view.
        new IntersectionObserver(function (entries) {
          if (!animated && entries[0].isIntersecting && container.getBoundingClientRect().top >= 0) {
            animated = true;
            runSequence();
          }
        }, { threshold: 0.2 }).observe(container);

        // Reset when scrolled back above the viewport.
        new IntersectionObserver(function (entries) {
          if (animated && !entries[0].isIntersecting && container.getBoundingClientRect().top > window.innerHeight) {
            animated = false;
            reset();
          }
        }, { threshold: 0 }).observe(container);
      });
    }
  };
})(jQuery, Drupal, once);
